import { Notification } from '../Types/Notification';
import { getApiInstance } from './Api';

export class NotificationApi {
  /**
   * Get user notifications
   * @param limit Maximum number of notifications to return
   * @returns Array of notifications
   */
  async getNotifications(limit: number = 10): Promise<Notification[]> {
    const response = await getApiInstance().get<{
      notifications: Notification[];
    }>(`/notifications?limit=${limit}`);
    return response.data.notifications.map((n) => new Notification(n));
  }

  /**
   * Mark a notification as read
   * @param id Notification ID
   * @returns The updated notification
   */
  async markAsRead(id: string): Promise<Notification> {
    const response = await getApiInstance().post<{
      notification: Notification;
    }>(`/notifications/${id}/read`);
    return response.data.notification
      ? new Notification(response.data.notification)
      : undefined;
  }
}
